(function() {
    var urlParams = new URLSearchParams(window.location.search),
        layoutValue = urlParams.get('layout'),
        imageValue = urlParams.get('image');

    if (layoutValue && imageValue) {
        document.documentElement.classList.add('layout_' + layoutValue);
        var imageContainer = document.querySelectorAll('.collection_layout_image')[0];
        if (imageContainer && window.ShopifyFileBaseUrl) {
            var fullImageUrl = window.ShopifyFileBaseUrl + imageValue,
                imgElement = document.createElement('img');
                
            imgElement.src = fullImageUrl;
            imgElement.alt = "Collection Image";
            imgElement.loading = "eager";                
            imageContainer.appendChild(imgElement);
        }
    }
})();